import { AccessRightsRouteGurd } from './core/routegurds/accessrightsroutegurd';
import { ShellDataResolver } from './core/resolvers/shell-data.resolver';
import { EmptyComponent } from './empty/empty.component';
import { MsalGuard } from '@azure/msal-angular';
import { Routes } from '@angular/router';
import { ShellComponent } from './shell/shell.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { ShellAuthGuard } from './core/guards/ordered-async.guard';

export const APP_ROUTES: Routes = [
  {
    path: '',
    canActivate: [ShellAuthGuard],
    resolve: {
      resolved: ShellDataResolver
    },
    component: ShellComponent,
    children: [
      { path: 'Admin', loadChildren: () => import('./u2-admin/u2-admin.routes').then(r => r.U2_ADMIN_ROUTES) },
      { path: 'Admin/CustomerService', loadChildren: () => import('./u2-person/u2-person.routes').then(r => r.U2_PERSON_ROUTES) },
      { path: 'Admin', loadChildren: () => import('./u2-person/u2-person.routes').then(r => r.U2_PERSON_ROUTES) },
      { path: 'PayRates', loadChildren: () => import('./u2-payrates/u2-payrates.routes').then(r => r.U2_PAYRATES_ROUTES) },
      { path: 'Admin', loadChildren: () => import('./u2-payrates/u2-payrates.routes').then(r => r.U2_PAYRATES_ROUTES) },
      { path: 'Payroll', loadChildren: () => import('./u2-payroll/u2-payroll.routes').then(r => r.U2_PAYROLL_ROUTES) },
      { path: 'Maintenance', loadChildren: () => import('./u2-admin/u2-admin.routes').then(r => r.U2_ADMIN_ROUTES) },
      { path: 'Maintenance', loadChildren: () => import('./u2-maintenance/u2-maintenance.routes').then(r => r.U2_MAINTENANCE_ROUTES) },
      { path: 'Authorizations', loadChildren: () => import('./u2-maintenance/u2-maintenance.routes').then(r => r.U2_MAINTENANCE_ROUTES) },
      { path: 'Admin', loadChildren: () => import('./u2-maintenance/u2-maintenance.routes').then(r => r.U2_MAINTENANCE_ROUTES) },
      { path: 'Billing/Inquiry', loadChildren: () => import('./u2-inquiry/u2-inquiry.routes').then(r => r.U2_INQUIRY_ROUTES) },
      { path: 'Billing/Process', loadChildren: () => import('./u2-process/u2-process.routes').then(r => r.U2_PROCESS_ROUTES) },
      { path: 'Transactions', loadChildren: () => import('./u2-admin/u2-admin.routes').then(r => r.U2_ADMIN_ROUTES) },
      { path: 'Transactions', loadChildren: () => import('./u2-process/u2-process.routes').then(r => r.U2_PROCESS_ROUTES) },
      { path: 'UTEX', loadChildren: () => import('./u2-utex/u2-utex.routes').then(r => r.U2_UTEX_ROUTES) },
      { path: 'SOLOMON', loadChildren: () => import('./u2-solomon/u2-solomon.routes').then(r => r.U2_SOLOMON_ROUTES) },
      {
        path: 'CaregiverConversion', loadChildren: () =>
          import('./u2-caregiver-conversion-editor/u2-caregiver-conversion.routes').then(r => r.U2_CAREGIVER_CONVERSION_EDITOR_ROUTES)
      },
      { path: 'FEA', loadChildren: () => import('./u2-fea/u2-fea.routes').then(r => r.U2_FEA_ROUTES) },
      {
        path: 'Billing/ClaimsSetup', loadChildren: () => import('./u2-claims-setup/u2-claims-setup.routes')
          .then(r => r.U2_CLAIMS_SETUP_ROUTES)
      },
      { path: 'GL', loadChildren: () => import('./u2-claims-setup/u2-claims-setup.routes').then(r => r.U2_CLAIMS_SETUP_ROUTES) },
      { path: 'Billing', loadChildren: () => import('./u2-claims-setup/u2-claims-setup.routes').then(r => r.U2_CLAIMS_SETUP_ROUTES) },
      { path: 'code', component: EmptyComponent, pathMatch: 'full', canActivate: [MsalGuard, AccessRightsRouteGurd] },
      { path: 'unauthorized', component: UnauthorizedComponent, pathMatch: 'full', canActivate: [MsalGuard, AccessRightsRouteGurd] },
      { path: '**', component: EmptyComponent, pathMatch: 'full', canActivate: [MsalGuard, AccessRightsRouteGurd] },
    ]
  },
];
